export function groupByPessoa({ pessoas = [], registros = [], itens = [] }) {
    const mapa = new Map();

    // index rápido de itens por id
    const itensMap = new Map();
    itens.forEach((i) => {
        itensMap.set(i.id, i);
    });

    // index de registros por (pessoaId + itemId)
    const registrosIndex = new Map();

    registros.forEach((r) => {
        const pessoaId = r?.createdUser;
        const itemId = r?.itemId || r?.homologationItemId;

        if (!pessoaId || !itemId) return;

        const key = `${pessoaId}_${itemId}`;

        if (!registrosIndex.has(key)) {
            registrosIndex.set(key, []);
        }

        registrosIndex.get(key).push(r);
    });

    pessoas.forEach((p) => {
        const pessoaId = p?.pessoaId;
        const itemId = p?.itemId;

        if (!pessoaId) return;

        if (!mapa.has(pessoaId)) {
            mapa.set(pessoaId, {
                pessoaId,
                pessoa: p?.Pessoa?.descricao || '-',
                papelPrincipal: p?.Papel?.descricao || '-',

                itens: new Set(),
                registros: 0,

                atrasado: false,
                pendente: false,

                vinculos: [],
            });
        }

        const row = mapa.get(pessoaId);

        row.vinculos.push(p);

        if (!itemId) return; // responsável geral não entra no cálculo de item

        row.itens.add(itemId);

        const item = itensMap.get(itemId);

        const prazoVenceu = item?.dataFim && new Date() > new Date(item.dataFim);

        const key = `${pessoaId}_${itemId}`;

        const regs = registrosIndex.get(key) || [];

        row.registros += regs.length;

        const concluiu = regs.some((r) => r?.Situacao?.concluiRegistro);

        if (!concluiu) {
            if (prazoVenceu) {
                row.atrasado = true;
            } else {
                row.pendente = true;
            }
        }
    });

    const resultado = [];

    mapa.forEach((row) => {
        let status = 'Concluído';

        if (row.atrasado) status = 'Atrasado';
        else if (row.pendente) status = 'Pendente';

        resultado.push({
            pessoaId: row.pessoaId,
            pessoa: row.pessoa,
            papelPrincipal: row.papelPrincipal,
            itens: row.itens.size,
            registros: row.registros,
            status,
            vinculos: row.vinculos,
        });
    });

    return resultado;
}
